import type { FaireProductEntity } from "../../entity_types/product";

export const p_exng7zy6ez: FaireProductEntity = {
  token: "p_exng7zy6ez",
  type: "product",
  name: "Unicorn Dreams Whipped Body Butter",
  brandToken: "b_e025dncg",
  brandName: "AMINNAH",
  imageUrl:
    "https://cdn.faire.com/fastly/569f64c7efe6f883e0a1a396f24cffc7912d763781bb6d94b63452074e2d41bf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4bae10757844e37c4d3d317241f6fc2fce29cf41a8aab6193a931995fe17d4c2.jpeg",
    "https://cdn.faire.com/fastly/2d2e107dd6eea7564936742e20e0c9c080cd5608df61544087a3d605f300bf09.jpeg",
    "https://cdn.faire.com/fastly/c9179ed2587838f3eff325d37615a957b0b81d7b44363aabb8bd439b4bf9efb1.jpeg",
    "https://cdn.faire.com/fastly/cdca17385f3d9e2f4bb268cc94e7e614abbc02f2dd39ef64c6c9e4fd0ed4d80f.jpeg",
    "https://cdn.faire.com/fastly/67b97c6f409710bcc03c7fe6a328c09689f054a37c8149ae733c95fe56cf243b.jpeg",
  ],
  priceDollars: 15.95,
  description:
    "Our Unicorn Dreams Whipped Body Butter is made with all natural ingredients such as coconut oil, coco butter, shea butter, and vitamin E.\n\nThis body butter is a blend of organic oils and butters such as coco butter, mango butter, coconut oil, and vitamin E. Helps to keep the skin supple, and protects the skins natural barrier. Soften and conditions your skin, help support elasticity, and locks in moisture and hydration. \n\nScented with notes of pink and blue cotton candy sweet spun-sugar delight! The smell will bring back childhood memories.\n\nHow To Use: Apply body butter all over your body after a shower or any time of the day to comfort and nourish your skin.\n\n\n\nIngredient List:\n\nOrganic Shea Butter, Coco butter, Mango Butter, Coconut Oil, Jojoba Oil, Vitamin E, Fragrance, Cosmetic mica \nLabubu, Halloween, Fall, Candles, Back to School, Fall Decor, Dubai Chocolate, Christmas 2025, Fall 2025, Jewelry, Christmas, Halloween Decor, Coffee, Mahjong, Candy, Tea, Christmas Ornaments, Pumpkin, Labubu Dolls, Fall Decor 2025, Books, Soap, Tallow, Hand Sanitizer, Soaps, Touchland Hand Sanitizer, Bath Bomb, White Label Products, Goat Milk Soap, Private Label Products, Private Label, Bath Salts, Hand Cream, Shower Steamers, Beef Tallow, Perfume, Lip Balm, Soaps Wholesale, Lip Balms, Spa, Tallow Skin Care, Lotion.",
  tags: [],
  msrpDollars: 31.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:18.023Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
